const messages = {
  title: "Mijn persoonlijk puntenoverzicht",
  desc: "Hier kunt u uw persoonlijke Bridgestone Plus-puntenoverzicht bekijken. Houd er rekening mee dat er enige vertraging kan optreden bij het registreren van uw bandenbestellingen.",
  score: "Puntensaldo",
  regularPoints: "Punten door bandenaankopen",
  boosterPoints: "Punten door boosters",
  date: "Datum",
  supplySourceReason: "Label",
  article: "Artikel",
  brand: "Merk",
  product: "Product",
  type: "Type",
  inch: "Velgmaat",
  season: "Seizoen",
  amount: "Aantal",
  standardPoints: "Punten",
  boosterProduct: "Booster product",
  boosterSeason: "Booster seizoen",
  otherActions: "Andere actie of oorzaak",
  totalPoints: "Puntentotaal",
  income: "Toegevoegd",
  spending: "Uitgegeven",
  lastMonth: "Eindtotaal",
  loadMore: "Meer laden",
  typeFilter: "Filter op aankoop",
  dateFilter: "Filter op datum",
  customer_number: "Klantnummer",
  currentPoints: "Actuele punten",
  calculationDate: "Berekeningsdatum",
  positivePoints: "Positieve punten (sinds lidmaatschap)",
  negativePoints: "Afgetrokken punten (sinds lidmaatschap)",
  tyresAmount: "Volume (sinds lidmaatschap)",
  pointsTotal: "Puntentotaal",
  currentPointState: "Huidige puntenstatus",
  unlockedPoints: "Ontgrendelde punten",
  lockedPoints: "Geblokkeerde punten (huidig jaar)",
  currentKickbackState: "Huidige bonus",
  pointsFromCurrentYear: "Toevoeging: punten van het huidige jaar ({year})",
  pointsAtRiskOfExpiry: "Te besteden punten tot 31.03.{year}",
  points: "punten",
  noDataFound: "Geen gegevens gevonden",
  seasons: {
    summer: "Zomer",
    winter: "Winter",
    all: "All Seasons",
  },
};
export default {
  messages,
};
